import { DealerRelatedUser } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';

import { t } from '@translations';
import { fullDateAndTime } from '@utils/date.utils';
import { CustomerDeleteActionButton } from './CustomerDeleteActionButton';

export const getUserItems = (
  user: DealerRelatedUser,
  canEditData?: boolean,
  isBerema?: boolean
) => [
  { fieldName: 'userName', fieldValue: [user.firstName, user.lastName].filter(Boolean).join(' ') },
  { fieldName: 'userEmail', fieldValue: user.userEmail },
  ...(isBerema ? [{ fieldName: 'userPhoneNumber', fieldValue: user.userPhoneNumber }] : []),
  { fieldName: 'lastLogin', fieldValue: fullDateAndTime(user.lastLogin) },
  ...(canEditData
    ? [
        {
          fieldName: 'delete',
          fieldValue: <CustomerDeleteActionButton userEmail={user.userEmail} />,
        },
      ]
    : []),
];

export const getUserColumns = (canEditData?: boolean, isBerema?: boolean) => [
  {
    key: 'userName',
    name: t(TextCodes.Dealer.Details.Name),
    sortable: true,
  },
  {
    key: 'userEmail',
    name: t(TextCodes.Dealer.Details.Email),
    sortable: true,
  },
  ...(isBerema
    ? [
        {
          key: 'userPhoneNumber',
          name: t(TextCodes.Dealer.Details.PhoneNumber),
          sortable: true,
        },
      ]
    : []),
  {
    key: 'lastLogin',
    name: t(TextCodes.Dealer.Details.LastLogin),
    sortable: true,
  },

  ...(canEditData
    ? [
        {
          key: 'delete',
          name: t(TextCodes.Base.Delete),
          sortable: false,
        },
      ]
    : []),
];

export const ADDRESS_TYPES = {
  Public: 'Public', //[1, 5],
  Shipping: 'Shipping', //[2, 3, 6, 7],
  Billing: 'Billing', //[4],
};

export const checkboxFormDataParser = (checkboxList: string[] | string | boolean): string[] => {
  return typeof checkboxList === 'string'
    ? [checkboxList]
    : Array.isArray(checkboxList)
    ? checkboxList
    : [];
};
